import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 3.75198V9.22003C2 9.84182 2.24506 10.438 2.68396 10.8769L9.12127 17.3142C10.0357 18.2286 11.517 18.2286 12.4314 17.3142L17.3142 12.4314C18.2286 11.517 18.2286 10.0357 17.3142 9.12128L10.8769 2.68398C10.438 2.24507 9.84181 2.00001 9.22002 2.00001H3.75563C2.78638 1.99636 2 2.78273 2 3.75198ZM6.09647 4.9224C6.40688 4.9224 6.70458 5.04571 6.92408 5.26521C7.14358 5.48471 7.26689 5.78241 7.26689 6.09282C7.26689 6.40323 7.14358 6.70093 6.92408 6.92043C6.70458 7.13993 6.40688 7.26324 6.09647 7.26324C5.78605 7.26324 5.48835 7.13993 5.26886 6.92043C5.04936 6.70093 4.92605 6.40323 4.92605 6.09282C4.92605 5.78241 5.04936 5.48471 5.26886 5.26521C5.48835 5.04571 5.78605 4.9224 6.09647 4.9224Z",
		fill: "#0D2976"
	})
});
export default SvgTag;
